// React Base Component
import React from 'react'

// Custom Components
import SplitLayout from './SplitLayout'
import ResetPasswordForm from './ResetPasswordForm'

class Login extends React.Component {
    render() {
        return (
            <SplitLayout page={<ResetPasswordForm className="w-100" />} />
        )
    }
}

export default Login
